import React from "react";
import styles from "./index.module.scss";
import { Link } from "react-router-dom";
import Sound from "react-sound";

function Scene() {
  return (
    <div className={styles.heroContainer}>
      <Sound url={"bgm.mp3"} playStatus={"PLAYING"} volume={100} loop={true} />
      <div className={styles.homeContainer}>
        <h1>Story Mode</h1>
        <div className={styles.storyList}>
          <ul>
            <li>
              <Link to="mahabharat-story">
                <h1>Ramayan</h1>
              </Link>
            </li>
            <li>
              <Link to="mahabharat-story">
                <h1>Mahabharat</h1>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Scene;
